import client from './client';
import type { EntitlementsListResponse } from './types/entitlements';

export type { EntitlementResponse, EntitlementsListResponse, AcquisitionType } from './types/entitlements';

export async function fetchEntitlements(): Promise<EntitlementsListResponse> {
  const response = await client.get<EntitlementsListResponse>('/api/v1/entitlements');
  return response.data;
}
